import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';

const KEY = 'dib_cart';
const CartContext = createContext(null);

const load = () => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
};

export const CartProvider = ({ children }) => {
    const [items, setItems] = useState(load);

    useEffect(() => { localStorage.setItem(KEY, JSON.stringify(items)); }, [items]);

    const add = (m, qty = 1) => setItems((prev) => {
        const found = prev.find((i) => i.id === m.id);
        if (found) return prev.map((i) => (i.id === m.id ? { ...i, qty: i.qty + qty } : i));
        return [...prev, { id: m.id, slug: m.slug, name: m.name, price: Number(m.price), image_url: m.image_url, qty }];
    });
    const setQty = (id, qty) => setItems((prev) => prev.map((i) => (i.id === id ? { ...i, qty: Math.max(1, qty) } : i)));
    const remove = (id) => setItems((prev) => prev.filter((i) => i.id !== id));
    const clear = () => setItems([]);

    const value = useMemo(() => ({
        items, add, setQty, remove, clear,
        count: items.reduce((s, i) => s + i.qty, 0),
        subtotal: items.reduce((s, i) => s + i.qty * i.price, 0),
    }), [items]);

    return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
};

export const useCart = () => useContext(CartContext);
